"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhispersOfTheAncientOneAbilityHandler = exports.WhispersOfTheAncientOneActorAbilityFactory = exports.WhispersOfTheAncientOneAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class WhispersOfTheAncientOneAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WhispersOfTheAncientOne;
        this.__typeName = "WhispersOfTheAncientOne";
    }
}
exports.WhispersOfTheAncientOneAbilityArgs = WhispersOfTheAncientOneAbilityArgs;
let WhispersOfTheAncientOneActorAbilityFactory = class WhispersOfTheAncientOneActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WhispersOfTheAncientOne", "OneAllies", 0);
    }
};
WhispersOfTheAncientOneActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WhispersOfTheAncientOne")
], WhispersOfTheAncientOneActorAbilityFactory);
exports.WhispersOfTheAncientOneActorAbilityFactory = WhispersOfTheAncientOneActorAbilityFactory;
let WhispersOfTheAncientOneAbilityHandler = class WhispersOfTheAncientOneAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAllyOrSelf] = ability.args.target.actorIds;
        sequence.push(new core_1.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "WhispersOfTheAncientOne", "casting"));
        container.applyHealing({
            sequence,
            healerId: ability.invokerId,
            targetId: selectedAllyOrSelf,
            amount: container.getPercentOfBaseHealth(selectedAllyOrSelf, 10),
            onApplied: (sequence) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAllyOrSelf, "feet"), "DivineHealingWinds"));
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAllyOrSelf, "chest"), "PinkGlyph"));
                const effects = container.getHarmfulEffects(selectedAllyOrSelf);
                for (const effect of effects) {
                    container.cancelEffect(sequence, effect.id);
                }
            }
        });
    }
};
WhispersOfTheAncientOneAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WhispersOfTheAncientOne)
], WhispersOfTheAncientOneAbilityHandler);
exports.WhispersOfTheAncientOneAbilityHandler = WhispersOfTheAncientOneAbilityHandler;
